import {db} from "@/firebase/init";
import _ from "lodash";

export default {
    data() {
        return {
             urgentSupportTaskListener: null,
             migrationSupportTaskListener: null,
             uniqueSupportTaskListener: null,
             otherSupportTaskListener: null,
             notInWpoTaskListener: null,
             backUpSupportTaskListener: null,
             urgentSupportTasks: [],
             migrationSupportTasks: [],
             uniqueVisitSupportTasks: [],
             resolvedSupportTasks: [],
             otherSupportTasks: [],
             notInWpoSupportTasks: [],
             backUpSupportTasks: [],
        };
    },
    methods: {
        async fetchResolvedSupportTasks(){
            this.resolvedSupportTasks= []
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'resolved')
                .where('type', '==', 'support')
                .orderBy("resolvedAt", "desc")
                .limit(500).get();
            if(ref.size){
                ref.forEach(el => {
                    this.resolvedSupportTasks.push({docId: el.id, ...el.data()})
                })
            }
            console.log('These resolved support tasks from mixin', this.resolvedSupportTasks )
        },
        async fetchMissingCpanelDomainSupportTasksSnapShot(){
            this.otherSupportTaskListener = [];
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', '==', 'C-Panel Missing Domain')
                .orderBy("text", "desc")
                .orderBy("createdAt", "desc")
            this.otherSupportTaskListener = ref.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Urgent Support Task Added from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.otherSupportTasks.push({...data})
                    } else if (changeDoc.type === 'modified') {
                        console.log('New Urgent Support Task Modified from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        let taskToUpdate = this.otherSupportTasks.find((task) => task.docId === data.docId );
                        const allKeys = Object.keys(data);
                        for (const key of allKeys){
                            taskToUpdate[key] = data[key];
                        }
                    } else if(changeDoc.type === 'removed') {
                        console.log('New Urgent Support Task Removed from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.otherSupportTasks = this.otherSupportTasks.filter(task => task.docId !== data.docId);
                    }
                });
            });
            console.log('These missing Cpanel support tasks from mixin', this.otherSupportTasks )
        },
        async fetchUniqueVisitSupportTasksSnapShot(){
            console.log('I was called here')
            this.uniqueVisitSupportTasks = [];
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', '==', 'Domain Not Found')
                .orderBy("text", "desc")
                .orderBy("createdAt", "desc")
            this.uniqueSupportTaskListener = ref.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Unique Support Task Added from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.uniqueVisitSupportTasks.push({...data})
                    } else if (changeDoc.type === 'modified') {
                        console.log('New Unique Support Task Modified from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        let taskToUpdate = this.uniqueVisitSupportTasks.find((task) => task.docId === data.docId );
                        const allKeys = Object.keys(data);
                        for (const key of allKeys){
                            taskToUpdate[key] = data[key];
                        }
                    } else if(changeDoc.type === 'removed') {
                        console.log('New Unique Support Task Removed from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.uniqueVisitSupportTasks = this.uniqueVisitSupportTasks.filter(task => task.docId !== data.docId);
                    }
                });
            });
            console.log('These unique support tasks from mixin', this.uniqueVisitSupportTasks )
        },
        async fetchUrgentSupportTasksSnapShot(){
            this.urgentSupportTasks= []
            const supportTaskTypes = ['Backup Failure', 'New Migration', 'Migration Initiated','Domain Not Found','C-Panel Missing Domain' ,'Backup Failure', 'C-Panel Missing Domain']
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', 'not-in', supportTaskTypes)
                .orderBy("text", "desc")
                .orderBy("createdAt", "desc")
            this.urgentSupportTaskListener = ref.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Urgent Support Task Added from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.urgentSupportTasks.push({...data})
                    } else if (changeDoc.type === 'modified') {
                        console.log('New Urgent Support Task Modified from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        let taskToUpdate = this.urgentSupportTasks.find((task) => task.docId === data.docId );
                        const allKeys = Object.keys(data);
                        for (const key of allKeys){
                            taskToUpdate[key] = data[key];
                        }
                    } else if(changeDoc.type === 'removed') {
                        console.log('New Urgent Support Task Removed from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.urgentSupportTasks = this.urgentSupportTasks.filter(task => task.docId !== data.docId);
                    }
                });
            });
            console.log('These Urgent support tasks from mixin', this.urgentSupportTasks )
        },
        async fetchMigrationSupportTasksSnapShot(){
            this.migrationSupportTasks = [];
            const supportMigrationTypes = ['New Migration', 'Migration Initiated']
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', 'in', supportMigrationTypes)
                .orderBy("text", "desc")
                .orderBy("createdAt", "desc")
            this.migrationSupportTaskListener = ref.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Pending Support Task Added from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.migrationSupportTasks.push({...data})
                    } else if (changeDoc.type === 'modified') {
                        console.log('New Pending Support Task Modified from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        let taskToUpdate = this.migrationSupportTasks.find((task) => task.docId === data.docId );
                        const allKeys = Object.keys(data);
                        for (const key of allKeys){
                            taskToUpdate[key] = data[key];
                        }
                    } else if(changeDoc.type === 'removed') {
                        console.log('New Pending Support Task Removed from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.migrationSupportTasks = this.migrationSupportTasks.filter(task => task.docId !== data.docId);
                    }
                });
            });
            console.log('These migration support tasks from mixin', this.migrationSupportTasks )
        },
        async fetchNotInWpoTaskSnapShot(){
        this.notInWpoSupportTasks= []
         const notInWpoQuery = db.collection('NotInWPO_CP')
          this.notInWpoTaskListener = notInWpoQuery.onSnapshot(querySnapshot => {
            querySnapshot.docChanges().forEach(changeDoc => {
              if (changeDoc.type === 'added'){
               console.log('New Not in WPO Support Task Added from mixin');
               const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
               this.notInWpoSupportTasks.push({...data})
              }
              else if (changeDoc.type === 'modified') {
              const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
              let taskToUpdate = this.notInWpoSupportTasks.find((task) => task.id === data.id );
              const allKeys = Object.keys(data);
              for (const key of allKeys){
                  taskToUpdate[key] = data[key];
              }
              }
              else if (changeDoc.type === 'removed') {
              console.log('New Not in WPO Support Task Removed from mixin');
              const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
              this.notInWpoSupportTasks = this.notInWpoSupportTasks.filter(task => task.id !== data.id);
              }
            });
          });
        },
        async fetchBackUpSupportTasksSnapShot(){
            console.log('I was called here')
            this.backUpSupportTasks = [];
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', '==', 'Backup Failure')
                .orderBy("text", "desc")
                .orderBy("createdAt", "desc")
            this.backUpSupportTaskListener = ref.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Unique Support Task Added from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.backUpSupportTasks.push({...data})
                    } else if (changeDoc.type === 'modified') {
                        console.log('New Unique Support Task Modified from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        let taskToUpdate = this.backUpSupportTasks.find((task) => task.docId === data.docId );
                        const allKeys = Object.keys(data);
                        for (const key of allKeys){
                            taskToUpdate[key] = data[key];
                        }
                    } else if(changeDoc.type === 'removed') {
                        console.log('New Unique Support Task Removed from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.backUpSupportTasks = this.backUpSupportTasks.filter(task => task.docId !== data.docId);
                    }
                });
            });
            console.log('These unique support tasks from mixin', this.backUpSupportTasks )
        },


    },
}